import aeroConfig from './aeroswap.js';
import changeHeroConfig from './change-hero.js';
import changeNowConfig from './change-now.js';
import changellyConfig from './changelly.js';
import cicConfig from './cic.js';
import exolitConfig from './exolit.js';
import nexchangeConfig from './nexchange.js';
import simpleswapConfig from './simpleswap.js';
import switchainConfig from './switchain.js';
import { retry } from '@exodus/simple-retry';
import { InvalidAmountError, InvalidPayInAddressError, InvalidToTokenAddressError, OrderValidationError, ProviderVerifiersError, } from '../../../errors.js';
import { areAmountsValid } from '../../../utils.js';
const providers = {
    ...aeroConfig,
    ...changeHeroConfig,
    ...changeNowConfig,
    ...changellyConfig,
    ...cicConfig,
    ...exolitConfig,
    ...nexchangeConfig,
    ...switchainConfig,
    ...simpleswapConfig,
};
const getOrderFromProvider = async ({ providerOrder, fetchival, }) => {
    const getProviderOrder = providers[providerOrder.provider.slug];
    if (!getProviderOrder) {
        throw new ProviderVerifiersError({
            message: `Unknown verifier for ${providerOrder.provider.slug}`,
        });
    }
    const getProviderOrderWithRetry = retry(getProviderOrder, {
        delayTimesMs: ['1s', '2s'],
    });
    try {
        return await getProviderOrderWithRetry(providerOrder, fetchival);
    }
    catch (error) {
        let details = [];
        if (error instanceof Error) {
            details = ['message' in error ? `message: ${error.message}` : ''];
            if ('response' in error) {
                details.push('status' in error.response
                    ? `http status: ${error.response.status}`
                    : '');
            }
        }
        throw new ProviderVerifiersError({
            message: `Failed to get order details ${providerOrder.provider.slug}: ${details.filter(Boolean).join(', ')}`,
        });
    }
};
const checkOrderIsValidWithProvider = async ({ providerOrder, order, fetchival, }) => {
    const orderFromProvider = await getOrderFromProvider({ providerOrder, fetchival });
    const amountsValid = areAmountsValid(String(order.amount.value), orderFromProvider.depositAmount);
    if (!amountsValid) {
        throw new InvalidAmountError({
            expected: order.amount.value.toString(),
            actual: orderFromProvider.depositAmount.toString(),
            providerOrder,
            order,
        });
    }
    if (order.providerOrderId !== orderFromProvider.orderId) {
        throw new OrderValidationError({
            actual: orderFromProvider.orderId,
            order,
            providerOrder,
            expected: order.providerOrderId,
        });
    }
    if (order.payInAddress !== orderFromProvider.depositAddress) {
        throw new InvalidPayInAddressError({
            orderId: order.id,
            message: 'invalid pay in address',
        });
    }
    if (order.toAddress !== orderFromProvider.withdrawalAddress) {
        throw new InvalidToTokenAddressError({
            expected: order.toAddress,
            actual: orderFromProvider.withdrawalAddress,
            order,
            providerOrder,
        });
    }
};
export default checkOrderIsValidWithProvider;
